// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_authentication_authentication_module_ts":"adb5c4c213de509c","node_modules_echarts_index_js":"9ccd523829eaac1a"}[chunkId] + ".js";
};